/* ==========================================================================
   Universal Mega Menu — theme-agnostic Shopify mega menu
   Vanilla JS, no dependencies. Safe to load on any theme.
   ========================================================================== */
(function () {
  'use strict';

  var OPEN_DELAY = 60;    // hover-intent: ms before a panel opens
  var CLOSE_DELAY = 220;  // ms of grace before a panel closes
  var DESKTOP_MQ = '(min-width: 900px)';

  function initMegaMenu(root) {
    if (!root || root.dataset.ummReady === 'true') return;
    root.dataset.ummReady = 'true';

    var items = [].slice.call(root.querySelectorAll('[data-umm-item]'));
    var burger = root.querySelector('[data-umm-burger]');
    var drawer = root.querySelector('[data-umm-drawer]');
    var overlay = root.querySelector('[data-umm-overlay]');
    var closeBtn = root.querySelector('[data-umm-close]');
    var isDesktop = window.matchMedia(DESKTOP_MQ);
    var openTimer = null;
    var closeTimer = null;
    var openItem = null;

    /* ------------------------------------------------------------------
       Desktop panels
       ------------------------------------------------------------------ */

    function setOpen(item) {
      if (openItem === item) return;
      if (openItem) {
        openItem.classList.remove('umm__item--open');
        setExpanded(openItem, false);
      }
      openItem = item;
      if (item) {
        item.classList.add('umm__item--open');
        setExpanded(item, true);
        positionPanel(item);
      }
    }

    function setExpanded(item, value) {
      var link = item.querySelector('.umm__link');
      if (link && link.hasAttribute('aria-haspopup')) {
        link.setAttribute('aria-expanded', value ? 'true' : 'false');
      }
    }

    /* Keep boxed dropdowns inside the viewport */
    function positionPanel(item) {
      var panel = item.querySelector('[data-umm-panel]');
      if (!panel || !root.classList.contains('umm--boxed')) return;
      panel.classList.remove('umm__panel--flip');
      var rect = panel.getBoundingClientRect();
      if (rect.right > document.documentElement.clientWidth - 8) {
        panel.classList.add('umm__panel--flip');
      }
    }

    items.forEach(function (item) {
      var panel = item.querySelector('[data-umm-panel]');
      var link = item.querySelector('.umm__link');
      if (!panel) return;

      item.addEventListener('mouseenter', function () {
        if (!isDesktop.matches) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { setOpen(item); }, OPEN_DELAY);
      });

      item.addEventListener('mouseleave', function () {
        if (!isDesktop.matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          if (openItem === item) setOpen(null);
        }, CLOSE_DELAY);
      });

      /* Touch / pen: first tap opens the panel instead of following the link */
      link.addEventListener('click', function (event) {
        if (!isDesktop.matches) return;
        var pointerCoarse = window.matchMedia('(pointer: coarse)').matches;
        if (pointerCoarse && openItem !== item) {
          event.preventDefault();
          setOpen(item);
        }
      });

      /* Keyboard: Enter/Space/ArrowDown opens, Escape closes */
      link.addEventListener('keydown', function (event) {
        if (!isDesktop.matches) return;
        if (event.key === 'ArrowDown' || event.key === ' ') {
          event.preventDefault();
          setOpen(item);
          var first = panel.querySelector('a');
          if (first) first.focus();
        }
      });

      panel.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          setOpen(null);
          link.focus();
        }
      });

      /* Close when focus leaves the item (tab navigation) */
      item.addEventListener('focusout', function (event) {
        if (!isDesktop.matches) return;
        if (!item.contains(event.relatedTarget)) {
          if (openItem === item) setOpen(null);
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (openItem && !root.contains(event.target)) setOpen(null);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && openItem) setOpen(null);
    });

    /* ------------------------------------------------------------------
       Mobile drawer
       ------------------------------------------------------------------ */

    var lastFocused = null;

    function openDrawer() {
      lastFocused = document.activeElement;
      root.classList.add('umm--drawer-open');
      burger.setAttribute('aria-expanded', 'true');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      root.classList.remove('umm--drawer-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    if (burger) {
      burger.addEventListener('click', function () {
        root.classList.contains('umm--drawer-open') ? closeDrawer() : openDrawer();
      });
    }
    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('umm--drawer-open')) {
        closeDrawer();
      }
    });

    /* Simple focus trap inside the drawer */
    if (drawer) {
      drawer.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;
        var focusables = drawer.querySelectorAll(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    /* ------------------------------------------------------------------
       Expanding search bar
       ------------------------------------------------------------------ */

    var searchToggle = root.querySelector('[data-umm-search-toggle]');
    var searchBox = root.querySelector('[data-umm-search]');

    if (searchToggle && searchBox) {
      var searchInput = searchBox.querySelector('.umm__search-input');
      var searchClose = searchBox.querySelector('[data-umm-search-close]');

      var openSearch = function () {
        root.classList.add('umm--search-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        setTimeout(function () { if (searchInput) searchInput.focus(); }, 60);
      };

      var closeSearch = function () {
        root.classList.remove('umm--search-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      };

      searchToggle.addEventListener('click', function () {
        root.classList.contains('umm--search-open') ? closeSearch() : openSearch();
      });

      if (searchClose) searchClose.addEventListener('click', closeSearch);

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && root.classList.contains('umm--search-open')) {
          closeSearch();
        }
      });

      document.addEventListener('click', function (event) {
        if (
          root.classList.contains('umm--search-open') &&
          !searchBox.contains(event.target) &&
          !searchToggle.contains(event.target)
        ) {
          closeSearch();
        }
      });
    }

    /* ------------------------------------------------------------------
       Cart count — refresh when returning to the tab/page so the badge
       stays correct after items are added elsewhere
       ------------------------------------------------------------------ */

    var cartCount = root.querySelector('[data-umm-cart-count]');

    function refreshCartCount() {
      if (!cartCount || !window.fetch) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          cartCount.textContent = cart.item_count;
          cartCount.hidden = cart.item_count === 0;
        })
        .catch(function () {});
    }

    if (cartCount) {
      window.addEventListener('pageshow', refreshCartCount);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) refreshCartCount();
      });
    }

    /* Stagger index for the drawer's entrance animation */
    [].slice.call(root.querySelectorAll('.umm__drawer .umm__m-item')).forEach(function (el, index) {
      el.style.setProperty('--umm-i', index);
    });

    /* Drawer accordions */
    [].slice.call(root.querySelectorAll('[data-umm-accordion]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mItem = btn.closest('.umm__m-item');
        var wasOpen = mItem.classList.contains('umm__m-item--open');
        mItem.classList.toggle('umm__m-item--open', !wasOpen);
        btn.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
      });
    });

    /* Reset state when crossing the breakpoint */
    var onMqChange = function () {
      setOpen(null);
      closeDrawer();
    };
    if (isDesktop.addEventListener) {
      isDesktop.addEventListener('change', onMqChange);
    } else if (isDesktop.addListener) {
      isDesktop.addListener(onMqChange); // legacy Safari
    }

    /* ------------------------------------------------------------------
       Sticky: shadow when scrolled, hide on scroll down (optional)
       ------------------------------------------------------------------ */

    if (root.classList.contains('umm--sticky')) {
      var hideOnScroll = root.dataset.hideOnScroll === 'true';
      var lastY = window.scrollY;
      var ticking = false;

      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var y = window.scrollY;
          root.classList.toggle('umm--scrolled', y > 8);
          if (hideOnScroll && !root.classList.contains('umm--drawer-open')) {
            if (y > lastY && y > 160 && !openItem) {
              root.classList.add('umm--hidden');
            } else if (y < lastY) {
              root.classList.remove('umm--hidden');
            }
          }
          lastY = y;
          ticking = false;
        });
      }, { passive: true });
    }
  }

  function initAll() {
    [].slice.call(document.querySelectorAll('[data-umm]')).forEach(initMegaMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when the section is (re)loaded in the Shopify theme editor */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-umm]');
    if (root) {
      root.dataset.ummReady = 'false';
      initMegaMenu(root);
    }
  });
})();
